const steps = [
  {
    number: '01',
    icon: 'ri-user-smile-line',
    title: 'Проектирование образа',
    text: 'Мы определяем «роль» вашего аватара — будет ли это дружелюбный эксперт, вдохновляющий спикер или строгий консультант.',
    tag: 'Образ и стиль',
  },
  {
    number: '02',
    icon: 'ri-equalizer-line',
    title: 'Цифровая настройка эмоций',
    text: 'Мы калибруем темп речи и интонации (от уверенного B2B-тона до живого стиля соцсетей), чтобы аватар выглядел максимально естественно и вызывал доверие.',
    tag: 'Голос и интонации',
  },
  {
    number: '03',
    icon: 'ri-global-line',
    title: 'Мультиязычность',
    text: 'Обучаем вашего двойника говорить на нескольких языках, сохраняя вашу визуальную идентичность для захвата международных рынков.',
    tag: '20+ языков',
  },
];

export default function AIAvatarProcess() {
  return (
    <section className="py-14 sm:py-28 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="text-center mb-10 sm:mb-16">
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#1A2B4C]/08 border border-[#1A2B4C]/15 mb-5">
            <i className="ri-flow-chart text-[#C5A880] text-sm"></i>
            <span className="text-[#1A2B4C] text-xs font-bold font-['Montserrat'] uppercase tracking-widest">
              Процесс
            </span>
          </div>
          <h2 className="text-xl sm:text-4xl font-['Playfair_Display'] font-bold text-[#1A2B4C] mb-4 leading-tight">
            Как это работает. Простые шаги к вашему контенту
          </h2>
          <p className="text-gray-600 font-['Montserrat'] text-sm sm:text-base max-w-2xl mx-auto leading-relaxed text-center">
            Мы выстроили процесс так, чтобы от вас потребовалось минимум усилий. Детализация процесса — создание «магии» без кухни.
          </p>
          <div className="w-16 h-1 bg-[#C5A880] mx-auto rounded-full mt-6"></div>
        </div>

        <div className="relative">
          {/* Connector line (desktop only) */}
          <div className="hidden lg:block absolute top-16 left-[16.67%] right-[16.67%] h-0.5 bg-gradient-to-r from-[#C5A880]/30 via-[#C5A880] to-[#C5A880]/30 z-0"></div>

          {/* Mobile: vertical timeline line */}
          <div className="lg:hidden absolute left-8 top-8 bottom-8 w-0.5 bg-gradient-to-b from-[#C5A880]/20 via-[#C5A880]/60 to-[#C5A880]/20 z-0"></div>

          <div className="grid grid-cols-1 lg:grid-cols-3 gap-5 sm:gap-8 relative z-10">
            {steps.map((step) => (
              <div key={step.number} className="flex flex-col lg:items-center lg:text-center">
                {/* Mobile: horizontal layout with circle + card side by side */}
                <div className="flex items-start gap-4 lg:flex-col lg:items-center">
                  {/* Step circle */}
                  <div className="w-16 h-16 flex items-center justify-center rounded-full bg-[#1A2B4C] border-4 border-white shadow-md flex-shrink-0 relative z-10">
                    <i className={`${step.icon} text-xl sm:text-2xl text-[#C5A880]`}></i>
                  </div>

                  <div className="flex-1 bg-[#F9F5EF] rounded-2xl p-5 sm:p-8 border border-[#E8DDD0] hover:border-[#C5A880] transition-colors duration-300 lg:mt-6 lg:w-full">
                    <div className="text-xs text-[#C5A880] font-bold font-['Montserrat'] uppercase tracking-wider mb-1">
                      Шаг {step.number}
                    </div>
                    <h3 className="text-sm sm:text-lg font-bold text-[#1A2B4C] font-['Playfair_Display'] mb-3 leading-snug">
                      {step.title}
                    </h3>
                    <p className="text-gray-600 text-sm leading-relaxed font-['Montserrat'] mb-4 text-justify">
                      {step.text}
                    </p>
                    <span className="inline-flex items-center gap-1.5 bg-[#1A2B4C]/08 px-3 py-1.5 rounded-full text-xs font-semibold text-[#1A2B4C] font-['Montserrat']">
                      <i className="ri-check-line text-[#C5A880]"></i>
                      {step.tag}
                    </span>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}
